import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import firebase from 'firebase/app';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private user: Observable<firebase.User>;
  private userDetails: firebase.User = null;

  constructor(
    private afAuth: AngularFireAuth,
  ) {
    this.user = afAuth.authState;
    this.user.subscribe(user => {
        if (user) {
          this.userDetails = user;
          /*console.log(this.userDetails);*/
        } else {
          /*snackBar.open('Error en inicio de sesión', 'ok', {duration: 2000,});*/
          console.log('not login');
          this.userDetails = null;
        }
      }
    );
  }

  resetPasswordEmail(email: string) {
    return new Promise((resolve, reject) => {
      this.afAuth.sendPasswordResetEmail(email)
        .then((res: any) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  }

  doRegister(email, password) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(email, password)
        .then(res => {
          resolve(res);
        }, err => reject(err));
    });
  }

  authState() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.onAuthStateChanged(user => {
        if (user) {
          resolve(user);
        } else {
          resolve('error');
        }
      });
    });
  }

  authSingUp(email, password) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(email, password)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // authUpdatePass(password) {
  //   return this.afAuth.currentUser.updatePassword(password);
  // }

  authLogIn(email, password) {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.signInWithEmailAndPassword(email, password)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  isLoggedIn() {
    return this.userDetails != null;
  }

  logout() {
    return this.afAuth.signOut();
  }
}
